export const AUTH_ACCESS_TOKEN_STORAGE_KEY = 'access';
export const AUTH_REFRESH_TOKEN_STORAGE_KEY = 'refresh';
export const AUTH_OTP_VERIFIED_STORAGE_KEY = 'scalar_auth_otp_verified';
export const AUTH_OTP_VERIFIED_LEGACY_STORAGE_KEY = 'isOtpVerified';
export const AUTH_SIGN_IN_REMEMBER_STORAGE_KEY = 'scalar_auth_sign_in_remember';
export const AUTH_PENDING_BACKUP_CODES_STORAGE_KEY = 'scalar_auth_pending_backup_codes';
export const AUTH_PENDING_BACKUP_CODES_TTL_MS = 15 * 60 * 1000;
export const AUTH_PENDING_SIGN_IN_IDENTIFIER_STORAGE_KEY = 'scalar_auth_pending_sign_in_identifier';
export const AUTH_PENDING_SIGN_IN_IDENTIFIER_TTL_MS = 15 * 60 * 1000;
export const AUTH_STORAGE_PERSISTENCE_LOCAL = 'local';
export const AUTH_STORAGE_PERSISTENCE_SESSION = 'session';
export type AuthTokenPersistence = typeof AUTH_STORAGE_PERSISTENCE_LOCAL | typeof AUTH_STORAGE_PERSISTENCE_SESSION;

// sessionStorage: set after enterprise SAML/OIDC token exchange; cleared on password login and logout.
export const AUTH_ENTERPRISE_SSO_SESSION_STORAGE_KEY = 'scalar_auth_enterprise_sso_session';
